import type { Product } from '../types'

export const products: Product[] = [
  {
    id: 'frame-black-base',
    name: 'Marco Base Negro',
    description:
      'Marco de gafas negro mate con diseño clásico. Plástico alta calidad. Compatible con todas las cubiertas magnéticas.',
    price: 1190,
    type: 'frame',
    image: '/brandbook/1-frame_negro.svg',
    inStock: true,
  },
  {
    id: 'frame-transparent-base',
    name: 'Marco Base Transparente',
    description:
      'Marco de gafas transparente para un estilo fresco y moderno. Plástico de grado óptico. Compatible con todas las cubiertas magnéticas.',
    price: 1190,
    type: 'frame',
    image: '/brandbook/2-frame_trans.svg',
    inStock: true,
  },
  {
    id: 'cover-red',
    name: 'Cubierta Magnética Roja',
    description: 'Cubierta magnética intercambiable en rojo vibrante. Se acopla en segundos.',
    price: 90,
    type: 'cover',
    color: 'red',
    image: '/brandbook/14_red.svg',
    inStock: true,
  },
  {
    id: 'cover-yellow',
    name: 'Cubierta Magnética Amarilla',
    description: 'Cubierta magnética intercambiable en amarillo brillante. Se acopla en segundos.',
    price: 90,
    type: 'cover',
    color: 'yellow',
    image: '/brandbook/12_yellow.svg',
    inStock: true,
  },
  {
    id: 'cover-green',
    name: 'Cubierta Magnética Verde',
    description: 'Cubierta magnética intercambiable en verde naturaleza. Se acopla en segundos.',
    price: 90,
    type: 'cover',
    color: 'green',
    image: '/brandbook/13_green.svg',
    inStock: true,
  },
  {
    id: 'cover-blue',
    name: 'Cubierta Magnética Azul',
    description: 'Cubierta magnética intercambiable en azul océano. Se acopla en segundos.',
    price: 90,
    type: 'cover',
    color: 'blue',
    image: '/brandbook/11_blue.svg',
    inStock: true,
  },
]

export const getProductById = (id: string): Product | undefined => {
  return products.find((product) => product.id === id)
}

export const getProductsByType = (type: Product['type']): Product[] => {
  return products.filter((product) => product.type === type)
}
